'use strict';
import React from 'react';
import * as T from 'prop-types';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {
  ExportModalFormatSelector,
  ExportModalHOCView,
  formatHeaderLabel,
} from '../../../core-utilities/redux-observable-list-exports/components/ExportModalHOC';


export function BasePriorityExportView(props) {
  return (
    <ExportModalHOCView
      className={props.className}
      targetData={props.targetData}
      format={props.format}
      status={props.status}
      headerLabel={props.headerLabel}

      onReset={props.onReset}
      onDownload={props.onDownload}
      onClose={props.onClose}
      onSubmit={props.onSubmit}
    >
      <div className={props.className}>
        <div className="PriorityExport__heading">
          <span>
            {props.subHeaderLabel}
          </span>
        </div>

        <div className="full-padding-container form-response">
          <div className="item item-divider view-divider">
            {props.formatHeaderLabel}
          </div>
          <ExportModalFormatSelector
            format={props.format}
            onChangeFormatXlsx={props.onChangeFormatXlsx}
            onChangeFormatCsv={props.onChangeFormatCsv}
          />
        </div>
      </div>
    </ExportModalHOCView>
  );
}

BasePriorityExportView.propTypes = {
  className: T.string,
  subHeaderLabel: T.string,
};

BasePriorityExportView.defaultProps = {
  className: '',
};

export const PriorityExportView = I18nComponent(BasePriorityExportView, [
  formatHeaderLabel,
  {code: 'priorities.export.header.label', prop: 'headerLabel'},
  {code: 'priorities.export.subheader.label', prop: 'subHeaderLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/priorities/components/PriorityExport/PriorityExportView.js